// src/contexts/StoreContext.js
import React, { createContext, useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

// 1) Create the context object
export const StoreContext = createContext({
  store: null,
  loading: true,
});

// 2) Wrap your app in this provider to fetch the store once
export function StoreProvider({ children }) {
  const storeId = 'L04xmvO15r2j6tG7weyc';

  const [store, setStore] = useState(() => {
    try {
      const cached = localStorage.getItem('storeDetails');
      return cached ? JSON.parse(cached) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(!store);

  useEffect(() => {
    async function fetchStore() {
      try {
        const snap = await getDoc(doc(db, 'stores', storeId));
        if (snap.exists()) {
          const storeData = { id: snap.id, ...snap.data() };
          setStore(storeData);
          try {
            localStorage.setItem('storeDetails', JSON.stringify(storeData));
          } catch {}
        }
      } finally {
        setLoading(false);
      }
    }
    fetchStore();
  }, [storeId]);

  return (
    <StoreContext.Provider value={{ store, loading }}>
      {children}
    </StoreContext.Provider>
  );
}
